import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { marketingCategories, salesCategories, serviceCategories, webCategories, marketingHubTools, salesHubTools, serviceHubTools } from 'academy-common-lib/constants/categories';
export const CategoriesSubSections = {
  MARKETING: marketingCategories.slice(),
  SALES: salesCategories.slice(),
  SERVICE: serviceCategories.slice(),
  SERVICE_SUPPORT: serviceCategories.slice(),
  WEB_DESIGN_DEVELOPMENT: webCategories.slice()
};
export const HubspotToolsSubSections = {
  MARKETING_HUB_TOOLS: marketingHubTools.slice(),
  SALES_HUB_TOOLS: salesHubTools.slice(),
  SERVICE_HUB_TOOLS: serviceHubTools.slice()
};
export const SEARCH_FILTERS = [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.LEVEL, FILTER_TYPES.DURATION, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.LANGUAGE];